import { render } from "./domain-editor.vue?vue&type=template&id=8275637a&scoped=true"
import script from "./domain-editor.vue?vue&type=script&lang=js"
export * from "./domain-editor.vue?vue&type=script&lang=js"

import "./domain-editor.vue?vue&type=style&index=0&id=8275637a&scoped=true&lang=css"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8275637a"]])

export default __exports__